import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  name: 'titleTranslate',
  standalone: false,
  pure: true
})
export class TitleTranslatePipe implements PipeTransform {
  constructor(private localization: LocalizationService) {}

  transform<T extends { title?: string, languages?: Map<string, string> }>(item: T | null | undefined): string {
    if (!item) return '';
    return this.localization.titleTranslate(item);
  }
}